var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fg-input',_vm._g(_vm._b({staticClass:"fg-pass",attrs:{"type":_vm.currentType,"addon-right-icon":_vm.typeIcon,"disabled":_vm.isDisabled}},'fg-input',_vm.$attrs,false),_vm.$listeners),[_c('a',{attrs:{"slot":"addonRight"},on:{"click":_vm.toggleType},slot:"addonRight"},[_c('i',{class:_vm.typeIcon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }